export enum STATUS_SUBSCRIPTION {
    INIT,
    SELECT_FEE,
    SELECT_SERVICE,
    SUBSCRIPTION_OK,
    SUBSCRIPTION_KO,
    SUBSCRIPTION_CANCELED,
    CONTACT_SALES,
    CONTACT_SALES_OK,
    CONTACT_SALES_ERROR,
    CANCEL_OK,
    CANCEL_ERROR,
    SUBSCRIPTION_FREE_USED,
    SUBSCRIPTION_FREE_USED_NOT_VALID
}
